import { create } from 'zustand';
import type { EPCR } from '@/types';

/**
 * Active-EPCR store — exposes the currently-open EPCR + parent
 * incident id to surfaces OUTSIDE the EPCR page (specifically the
 * AppShell diamond-plate banner, which renders the Import CAD /
 * Import Vitals/ECG buttons in its toolbar slot).
 *
 * EPCRPage sets the active record on mount and clears on unmount.
 * Other pages that want context-aware affordances in the global
 * banner can consume this store the same way.
 */
interface ActiveEpcrState {
  epcr: EPCR | null;
  incidentId: string | null;
  setActive: (epcr: EPCR | null, incidentId: string | null) => void;
  clear: () => void;
}

export const useActiveEpcrStore = create<ActiveEpcrState>((set) => ({
  epcr: null,
  incidentId: null,
  setActive(epcr, incidentId) {
    set({ epcr, incidentId });
  },
  clear() {
    set({ epcr: null, incidentId: null });
  },
}));
